import React, { Component } from "react";
import Videojs from "video.js";
import "video.js/dist/video-js.css";
import { gaEvent } from "@Lib/ga";
import { host } from "@Services/url";

import styles from "./index.module.less";
import cx from "classnames";

interface IPlayer {
    height: string | number;
    width: string | number;
    src: string;
    id: string | number;
    poster: string;
    autoplay: boolean;
    onPlaying?: () => void;
    onEnded?: () => void;
    onReady?: (player: any) => void;
}

class VideoPlayer extends Component<IPlayer> {
    constructor(props) {
        super(props);
    }

    private player: any = {};

    state = {
        isPlay: false,
    };

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }
    componentDidMount() {
        const {
            height,
            width,
            src,
            id,
            autoplay,
            onPlaying,
            onEnded,
            onReady,
        } = this.props;
        const self = this;
        this.player = Videojs(
            id,
            {
                height,
                width,
                bigPlayButton: true,
                textTrackDisplay: false,
                errorDisplay: false,
                controlBar: true,
                autoplay,
                muted: true,
                type: "application/x-mpegURL",
            },
            function () {
                // this.play();
            }
        );
        this.player.src({ src });
        this.player.on("playing", async function () {
            onPlaying && onPlaying();
            self.setState({ isPlay: true });
        });
        this.player.on("pause", async function () {
            self.setState({ false: false });
        });
        this.player.on("ended", async function () {
            onEnded && onEnded();
        });
        this.player.on("ready", async function () {
            onReady && onReady(self.player);
        });
    }
    render() {
        const { isPlay } = this.state;
        const { poster, id } = this.props;

        return (
            <div className={styles["video-box"]}>
                <video
                    poster={poster}
                    id={id as string}
                    className="video-js"
                    controls
                    // preload="auto"
                ></video>
                <a
                    href={`${host.c}/buyCar`}
                    className={cx(styles["video-avtive-btn"], {
                        [styles["hide"]]: !isPlay,
                    })}
                    onClick={() =>
                        gaEvent("搶購趴活動", "活動音影", "立即參與活動")
                    }
                >
                    立即詢價
                </a>
            </div>
        );
    }
}

export default VideoPlayer;
